import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5931d05e&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=5931d05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5931d05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5931d05e')) {
      api.createRecord('5931d05e', component.options)
    } else {
      api.reload('5931d05e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=5931d05e&scoped=true&", function () {
      api.rerender('5931d05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/flow/edit.vue"
export default component.exports